import {
  randCity,
  randLatitude,
  randLongitude,
  randNumber,
  randState,
  randStreetAddress,
  randStreetName,
  randZipCode,
} from '@ngneat/falso';
import {
  AddressComponentType,
  AddressComponents,
  Countries,
  IAddressMetadata,
} from '@principle-theorem/principle-core/interfaces';
import { BaseFirestoreMock, Properties } from '@principle-theorem/shared';

export class AddressMock
  extends BaseFirestoreMock<Properties<IAddressMetadata>>
  implements Properties<IAddressMetadata>
{
  address = randStreetAddress();

  coordinates = {
    latitude: randLatitude(),
    longitude: randLongitude(),
  };

  components = {
    country: Countries.Australia,
    greaterArea: `${randCity()} Municipal Council`,
    postalCode: randZipCode(),
    state: randState(),
    streetName: randStreetName(),
    streetNumber: randNumber({ min: 1, max: 999 }).toString(),
    suburb: randCity(),
  };

  isVerified = true;
}

export function MockAddressComponents(
  countryCode: Countries = Countries.Australia
): AddressComponents {
  const components: { [key: string]: string } = {
    [AddressComponentType.Country]: countryCode,
    [AddressComponentType.State]: randState(),
    [AddressComponentType.City]: randCity(),
    [AddressComponentType.PostalCode]: randZipCode(),
    [AddressComponentType.StreetName]: randStreetName(),
    [AddressComponentType.StreetNumber]: randNumber({
      min: 1,
      max: 999,
    }).toString(),
  };

  if (Math.random() > 0.7) {
    components[AddressComponentType.Subpremise] = randNumber({
      min: 1,
      max: 50,
    }).toString();
  }

  return components;
}
